import { query } from 'src/utils/request';

// 档案回流列表查询
export function getArchiveReflowList(data) {
  return query('/zlb/api/sop/archive/reflow/list', {
    data,
    method: 'post',
  });
}

// 获取进度
export function getReflowProgress(data) {
  return query('/zlb/api/sop/archive/reflow/progress', {
    data,
    method: 'post',
  });
}

// 发起回流
export function startArchiveReflow(data) {
  return query('/zlb/api/sop/archive/reflow/start', {
    data,
    method: 'post',
  });
}
